<ion-header class="ion-no-border" [ngClass]="cssClass">
  <ion-toolbar class="ion-no-padding">
    <ion-buttons slot="start">
      <ion-button color="tertiary" expand="block" mode="md" (click)="closePage.emit()">
        <fa-icon slot="end" size="lg" [icon]="icon"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-text>
      <span class="ion-no-margin">
        <ng-content select="[slot=title]"></ng-content>
      </span>
    </ion-text>
    <ion-buttons slot="end">
      <ng-content select="[slot=button]"></ng-content>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
